<mat-expansion-panel
  class="tracking-map"
  hideToggle
  #expansionPanel
  [expanded]="expanded"
  (afterExpand)="mapLoad.emit()"
>
  <mat-expansion-panel-header class="tracking-map__header">
    <mat-panel-title class="tracking-map__header-title">
      <ui-svg-icon [name]="iconNames.Map"></ui-svg-icon>
      <span>{{ 'transportOrder.trackingMap.title' | translate }}</span>
      <ui-svg-icon [name]="expansionPanel.expanded ? iconNames.Up : iconNames.Down"></ui-svg-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <lib-tracking-map class="tracking-map-block" [trackingTransportMode]="transportMode" [mapData]="mapData">
  </lib-tracking-map>
</mat-expansion-panel>
